export default __webpack_public_path__ + "b0f3c8a8053ebc217d7c4eac737822d7.png";